import * as React from 'react'

import { Input, serializeCues } from '../../../../../Shared/index'

interface CuesFieldProps {
  handleCuesChange: any,
  cues: Array<string>,
  questionIndex: number;
}

const CuesField = ({ cues, handleCuesChange, questionIndex, }: CuesFieldProps) => {
  const cuesId = `cues-${questionIndex}`

  return (
    <div className="cues-field field">
      <div className="spread-label">
        <label htmlFor={cuesId} >Joining Words <span className="optional">(Optional)</span></label>
        <span>Make sure you separate words with commas “,”</span>
      </div>
      <Input
        className="bordered large"
        handleChange={handleCuesChange}
        id={cuesId}
        value={serializeCues(cues)}
      />
    </div>
  )
}

export default CuesField
